import {Component, Input, OnInit} from '@angular/core';
import {AuditHistoryRecordModel} from "../../../../core/services/audit-history/audit-history-record.model";
import {AuditHistoryFieldModel} from "../../../../core/services/audit-history/audit-history-field.model";
import {$translateKey, $translate} from "../../../../core/services/internationalization/localize.service";

@Component({
  selector: 'sb-audit-history-record',
  templateUrl: './audit-history-record.component.html',
  styleUrls: ['./audit-history-record.component.scss']
})
export class AuditHistoryRecordComponent implements OnInit {

  @Input()
  record: AuditHistoryRecordModel;

  isExpanded = false;
  isCollapsed = true;

  fieldHeaderLabel = "";
  fieldHeader2Label = "";
  fieldLabel = $translateKey("audithistory.label.field");
  labelLabel = $translateKey("audithistory.label.label");
  fieldTypeLabel = $translateKey("audithistory.label.field-type");
  referenceTableLabel = $translateKey("audithistory.label.reference-table");
  oldDisplayLabel = $translateKey("audithistory.label.old-display");
  oldValueLabel = $translateKey("audithistory.label.old-value");
  newDisplayLabel = $translateKey("audithistory.label.new-display");
  newValueLabel = $translateKey("audithistory.label.new-value");
  oldLabel = $translateKey("audithistory.label.old");
  newLabel = $translateKey("audithistory.label.new");

  constructor() { }

  ngOnInit(): void {
    this.fieldHeaderLabel = $translate("audithistory.label.field-header")`Field <i>${this.record.Field.displayValue}</i> of type <i>${this.record.FieldType.displayValue}</i>`;
    this.fieldHeader2Label = $translate("audithistory.label.field-header-2")`referring to table <i>${this.record.ReferenceTable?.displayValue}</i>`;
  }

  toggleExpanded() {
    this.isCollapsed = !this.isCollapsed;
    this.isExpanded = !this.isExpanded;
  }

  merge(displayValue: AuditHistoryFieldModel, value: AuditHistoryFieldModel): AuditHistoryFieldModel {
    return {
      displayValue: displayValue.displayValue || value.displayValue,
      value: displayValue.value || value.value
    };
  }
}
